
import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import AccommodationForm from '@/components/form/AccommodationForm';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { HomeIcon, AlertTriangle } from 'lucide-react';

const EditEstablishment = () => {
  const { id } = useParams();
  const location = useLocation();
  const [showInactiveAlert, setShowInactiveAlert] = React.useState(false);

  useEffect(() => {
    // Check if we came from dashboard with inactive status
    const searchParams = new URLSearchParams(location.search);
    const fromDashboard = searchParams.get('from') === 'dashboard';
    const status = searchParams.get('status');
    
    if (fromDashboard && status === 'Inactivo') {
      setShowInactiveAlert(true);
    }
  }, [location]);

  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/">
                  <HomeIcon className="h-4 w-4 mr-1" />
                  <span>Inicio</span>
                </BreadcrumbLink>
              </BreadcrumbItem>
            
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Edición de Establecimiento</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
          <h1 className="text-3xl font-bold mt-2 text-gray-900">Edición de Establecimiento</h1>
          <p className="text-gray-500 mt-1">
            Modifique los datos del establecimiento en el formulario
          </p>
        </div>

        {showInactiveAlert && (
          <Alert variant="destructive">
            <AlertTriangle className="h-4 w-4" />
            <AlertTitle>Resolver estado</AlertTitle>
            <AlertDescription>
              Este establecimiento tiene estado inactivo y requiere atención.
            </AlertDescription>
          </Alert>
        )}

        <AccommodationForm mode="edit" />
      </div>
    </MainLayout>
  );
};

export default EditEstablishment;
